import {
  useEffect,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import {
  Box,
  Flex,
  Grid,
  GridItem,
  Image
} from '@chakra-ui/react'
import {
  chatCredentialsSelectors,
  setChatSectionPage
} from 'store'
import { ImagesPng } from 'assets/images'
import { COLORS } from 'utils/styles'

import { getMatrixClient } from '../../Matrix/clientStore'

export const ContactList = ({
  room,
  lastMessage,
  lastMessageTime,
  setOpenRoomId
}) => {
  const dispatch = useDispatch()

  const [otherMemberUserId, setOtherMemberUserId] = useState(null)
  const [isOnline, setIsOnline] = useState(false)

  const { onlineMatrixList } = useSelector(chatCredentialsSelectors)

  const handleMsgTime = () => {
    if (!lastMessageTime) {
      return ''
    }

    const msgDate = new Date(lastMessageTime)
    const now = new Date()

    if (msgDate.toDateString() === now.toDateString()) {
      return msgDate.toLocaleTimeString('en-GB', {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      })
    }

    if (msgDate.getFullYear() !== now.getFullYear()) {
      return msgDate.getFullYear()
    }

    return msgDate.toLocaleDateString('en-GB', {
      day: 'numeric',
      month: 'short'
    })
  }

  const handleOtherPartyInfo = async () => {
    const client = getMatrixClient()
    const roomInfo = client?.getRoom(room?.roomId)
    const myUserId = roomInfo?.myUserId

    await roomInfo?.loadMembersIfNeeded()

    const memberInfo = roomInfo?.getJoinedMembers()
      .map((m) => m.userId)
      .filter((id) => id !== myUserId)

    if (memberInfo.length === 1) {
      setOtherMemberUserId(memberInfo[0])
    }
  }

  useEffect(() => {
    if (onlineMatrixList.includes(otherMemberUserId)) {
      setIsOnline(true)
    } else {
      setIsOnline(false)
    }
  }, [onlineMatrixList, otherMemberUserId])

  useEffect(() => {
    handleOtherPartyInfo()
  }, [])

  return (
    <Box
      onClick={() => {
        setOpenRoomId(room?.roomId)
        dispatch(setChatSectionPage(`chat-room-${room?.roomId}`))
      }}
      cursor="pointer"
      maxHeight="80px"
      color="white"
    >
      <Flex
        gap="10px"
        padding="3px"
        alignItems="center"
      >
        <Image
          src={room?.avatarUrl || ImagesPng.ProfileImage}
          height="60px"
          width="60px"
          backgroundColor="white"
          border={isOnline ? '2px solid rgb(84, 184, 58)' : ''}
          borderRadius="10%"
        />
        <Grid
          templateColumns="repeat(4, 1fr)"
          gap="10px"
          fontSize="16px"
          rowGap="0.9rem"
          width="calc(100% - 70px)"
          lineHeight="16px"
        >
          <GridItem
            border={`1px solid ${COLORS.white}`}
            fontWeight="600"
            whiteSpace="nowrap"
            height="22px"
            overflow="hidden"
            colSpan={lastMessage ? 3 : 5}
            borderRadius="5px"
            padding="2px 7.5px"
            backgroundColor="#4a4a4a"
          >
            {room?.name}
          </GridItem>

          {
            lastMessage
              ? (
                <>
                  <GridItem
                    border={`1px solid ${COLORS.white}`}
                    overflow="hidden"
                    textAlign="center"
                    height="22px"
                    colSpan={1}
                    borderRadius="5px"
                    padding="2px 4px"
                    backgroundColor="#4a4a4a"
                  >
                    {handleMsgTime()}
                  </GridItem>

                  <GridItem
                    border="1px solid white"
                    whiteSpace="nowrap"
                    overflow="hidden"
                    height="22px"
                    textOverflow="ellipsis"
                    colSpan={4}
                    borderRadius="5px"
                    padding="2px 7.5px"
                    backgroundColor="#4a4a4a"
                  >
                    {lastMessage}
                  </GridItem>
                </>
              )
              : ''
          }
        </Grid>
      </Flex>
    </Box>
  )
}
